
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { getStorage } from 'firebase/storage';
import { getFirestore } from 'firebase/firestore/lite';

const firebaseConfig = {
    apiKey: "AIzaSyDFipQj6lEogA9r_UXKLkSlvqFwo__zALM",
    authDomain: "portfolio-16f14.firebaseapp.com",
    projectId: "portfolio-16f14",
    storageBucket: "portfolio-16f14.appspot.com",
    messagingSenderId: "181797879016",
    appId: "1:181797879016:web:86cb89e7f1f95fc8f0dd5d"
};


const app = initializeApp(firebaseConfig);
export const auth = getAuth();
const provider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);


export const signInWithGoogle = () => signInWithPopup(auth, provider);